import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import accordion from './helpers/accordion';
import activeToggle from './helpers/activeAccordion';
import { testimonialsSwiper } from './homePage';
import sauron from './helpers/observatory';
import { headerJs } from './header';

headerJs()

function testimonialsCaller() {
    testimonialsSwiper()
}
// init testimonials swiper before enter the viewport
const testimonialSwiperTarget = document.querySelector(".testimonial-swiper")
testimonialSwiperTarget && sauron(testimonialSwiperTarget, testimonialSwiperTarget.dataset.id, testimonialsCaller)


// init accordionSwiper swiper before enter the viewport
const accordionSwiperTarget = document.querySelector('.accordionSwiper');
const accordions = document.querySelectorAll('[data-js="accordion"]')
accordionSwiperTarget && sauron(accordionSwiperTarget, accordionSwiperTarget.dataset.id, accordionSwiperFunc)



function accordionSwiperFunc() {
    const accordionSwiper = new Swiper(".accordionSwiper", {
        effect: "fade",
        fadeEffect: { crossFade: true }
    });
    accordions.forEach((elem, index) => {
        const accordionButton = elem.querySelector(".accordion-button")
        accordionButton.addEventListener('click', () => accordionSwiper.slideTo(index))
    });
}


setTimeout(() => {
    accordions.forEach((elem) => {
        accordion(elem, true);
    });
    activeToggle(accordions[0]);
    accordions[0].querySelector('[data-js="accordion-toggler"]').setAttribute('aria-expanded', "true")

}, 100)